export default Symbol('accordion')



// WEBPACK FOOTER //
// ./src/js/util/symbols/accordion.js